import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MixedCopy from '@components/molecules/mixed-copy/mixedCopy';
import Breadcrumb from '@components/molecules/breadcrumb/breadcrumb';
import { connectRefinementList } from 'react-instantsearch-dom';
import { motion } from 'framer-motion';
import Headline from '../../../atoms/headline/headline';
import Container from '../../../layout/container/container';
import StyledEducationLibraryStage from './educationLibraryStage.style';

const RefinementTabs = ({ items, refine }) => {
  const activeItem = items.find(item => item.isRefined);

  const handleItemClick = (event, itemValue) => {
    event.preventDefault();
    if (activeItem && activeItem.label === itemValue) {
      refine(itemValue); // Disable toggle down by always refining the item value
    } else {
      refine(itemValue);
    }
  };

  return (
    <div className="library-stage__tabs-grid">
      <div className="library-stage__tab">
        <div className="library-stage__tab-inner">
          <div className="library-stage__tab-content">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 44 44">
              <path
                fill="currentColor"
                d="M12.62 9.96a3.8 3.8 0 1 1-4.27-6.3 3.8 3.8 0 0 1 4.27 6.3ZM11.45 5.4a1.7 1.7 0 0 0-.94-.3v.03a1.7 1.7 0 0 0-1.7 1.67 1.7 1.7 0 1 0 2.64-1.4Zm12.23 6.03a3.82 3.82 0 1 1-4.23-6.36 3.82 3.82 0 0 1 4.23 6.36Zm-1.18-4.6a1.7 1.7 0 0 0-.95-.28v.01a1.7 1.7 0 0 0-.64 3.27 1.7 1.7 0 0 0 1.59-3Zm10.1 3.96a3.82 3.82 0 1 0 0-7.63 3.82 3.82 0 0 0 0 7.63Zm0-5.52a1.7 1.7 0 1 1-1.2.5c.32-.3.74-.49 1.2-.49Zm4.8 8.58c.33.28.56.67.63 1.1l2.09 11.91a.92.92 0 0 1-.92 1.08h-2.76a.47.47 0 0 0-.46.46v9.26a.46.46 0 0 1-.46.45h-1.2a.47.47 0 0 1-.46-.45v-9.26a.46.46 0 0 0-.46-.46h-1.58a.46.46 0 0 0-.46.46v9.26a.46.46 0 0 1-.46.45h-1.2a.46.46 0 0 1-.46-.45v-9.26a.46.46 0 0 0-.46-.46h-1.16v1.78a.92.92 0 0 1-.92.92h-1.28a.46.46 0 0 0-.46.46v9.2a.46.46 0 0 1-.46.46h-1.2a.46.46 0 0 1-.45-.46v-9.2a.46.46 0 0 0-.46-.46H20.8a.46.46 0 0 0-.46.46v9.2a.46.46 0 0 1-.46.46h-1.2a.46.46 0 0 1-.46-.46v-9.2a.46.46 0 0 0-.46-.46h-1.3a.92.92 0 0 1-.93-.92v-1.94h-1.2a.46.46 0 0 0-.45.46v9.3a.46.46 0 0 1-.46.46h-1.2a.46.46 0 0 1-.46-.46v-9.3a.46.46 0 0 0-.46-.46H9.73a.46.46 0 0 0-.46.46v9.3a.46.46 0 0 1-.46.46H7.6a.46.46 0 0 1-.46-.46v-9.25a.46.46 0 0 0-.46-.46H3.93a.92.92 0 0 1-.92-1.08l2.06-11.96c.08-.42.3-.81.63-1.1l1.97-1.66c.33-.28.75-.44 1.19-.44h5.9a.46.46 0 0 1 .46.46v1.16a.46.46 0 0 1-.46.46H8.22a.92.92 0 0 0-.92.76L5.46 25.1a.46.46 0 0 0 .45.53h9.12a.46.46 0 0 0 .46-.46v-8.28c0-.49.2-.95.54-1.3l1.46-1.43c.35-.35.81-.54 1.3-.54h5.52c.49 0 .95.18 1.3.52l1.46 1.45a1.84 1.84 0 0 1 .55 1.3v8.5a.46.46 0 0 0 .46.46h9.15a.46.46 0 0 0 .45-.53l-1.84-10.66a.92.92 0 0 0-.92-.77h-6.54a.46.46 0 0 1-.46-.46v-1.2a.46.46 0 0 1 .46-.45h5.87c.43-.01.85.14 1.18.4l1.97 1.67ZM25.37 28.38c.09-.08.14-.2.14-.32V16.62a.92.92 0 0 0-.92-.92h-6.04a.92.92 0 0 0-.92.92v11.44a.46.46 0 0 0 .46.46h6.96c.12 0 .24-.05.32-.14Z"
              />
            </svg>
            <button
              type="button"
              onClick={event => handleItemClick(event, 'teaching')}
              className="library-stage__tab-button"
            >
              <span className="library-stage__tab-title">Lernen begleiten</span>
              <span className="library-stage__tab-title-stretched" />
            </button>
          </div>
        </div>
        {activeItem?.label === 'teaching' && (
          <motion.div layoutId="tab-bg" className="library-stage__tab-bg" />
        )}
      </div>
      <div className="library-stage__tab">
        <div className="library-stage__tab-inner">
          <div className="library-stage__tab-content">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 44 44">
              <path
                fill="currentColor"
                d="M23.86 9.57a4.13 4.13 0 1 1-4.58-6.88 4.13 4.13 0 0 1 4.58 6.88ZM22.6 4.6c-.3-.2-.66-.31-1.03-.31v.01a1.84 1.84 0 0 0-1.52 2.86A1.84 1.84 0 1 0 22.6 4.6Zm-7.24 25.48a1 1 0 0 1-.29-.7c0-.83-.02-1.65-.03-2.47L15 24.45v-8.96a2 2 0 0 1 .59-1.4l1.58-1.56a2 2 0 0 1 1.4-.59h5.98a2 2 0 0 1 1.4.57l1.59 1.57a2 2 0 0 1 .6 1.4v9.2c0 .3 0 .6.02.9.02.59.05 1.19-.03 1.87v1.92a1 1 0 0 1-1 1h-1.38a.5.5 0 0 0-.5.5v9.95a.5.5 0 0 1-.5.5h-1.29a.5.5 0 0 1-.5-.5v-9.96a.5.5 0 0 0-.5-.5h-1.7a.5.5 0 0 0-.5.5v9.96a.5.5 0 0 1-.5.5h-1.3a.5.5 0 0 1-.5-.5v-9.95a.5.5 0 0 0-.49-.5h-1.41a1 1 0 0 1-.7-.29Zm10.35-2.14a.5.5 0 0 0 .14-.36V15.21a1 1 0 0 0-1-1h-6.52a1 1 0 0 0-1 1v12.37a.5.5 0 0 0 .5.5h7.53a.5.5 0 0 0 .35-.14Z"
              />
            </svg>
            <button
              type="button"
              onClick={event => handleItemClick(event, 'learning')}
              className="library-stage__tab-button"
            >
              <span className="library-stage__tab-title">Selbst lernen</span>
              <span className="library-stage__tab-title-stretched" />
            </button>
          </div>
        </div>
        {activeItem?.label === 'learning' && (
          <motion.div layoutId="tab-bg" className="library-stage__tab-bg" />
        )}
      </div>
    </div>
  );
};

RefinementTabs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      isRefined: PropTypes.bool,
      label: PropTypes.string
    })
  ).isRequired,
  refine: PropTypes.func.isRequired
};

const CustomRefinementTabs = connectRefinementList(RefinementTabs);

function EducationLibraryStage({ breadcrumb, headline, introCopy }) {
  return (
    <StyledEducationLibraryStage>
      {breadcrumb && <Breadcrumb className="library-stage__breadcrumb" entries={breadcrumb} />}
      <div className="library-stage__container">
        <div className="library-stage__gradient" />
        <div className="library-stage__gradient-front" />
        <Container>
          <div className="library-stage__content">
            <Headline primary tag="h1">
              {headline}
            </Headline>
            {introCopy && <MixedCopy fullWidth className="library-stage__copy" html={introCopy} />}
          </div>
        </Container>
      </div>
      <div className="library-stage__tabs">
        <Container>
          <CustomRefinementTabs attribute="learningType" defaultRefinement={['teaching']} />
        </Container>
      </div>
    </StyledEducationLibraryStage>
  );
}

EducationLibraryStage.propTypes = {
  breadcrumb: PropTypes.arrayOf(PropTypes.shape()),
  headline: PropTypes.string.isRequired,
  introCopy: PropTypes.string
};

const mapStateToProps = state => ({
  breadcrumb: state.app.pageData.breadcrumb,
  headline: state.app.pageData.headline,
  introCopy: state.app.pageData.introCopy
});

export default connect(mapStateToProps)(EducationLibraryStage);
